import { Injectable } from '@angular/core';
import { DerivativeCardInfo } from '@interfaces/a-organizar/derivativeCardInfo';
import {
  NdfDemandsCalculationsFiltered,
  NdfDemandsCalculationsOperation,
} from '@interfaces/a-organizar/ndfDemandsCalculationsFiltered';
import { NdfOperationFilteredSummary } from '@interfaces/a-organizar/ndfOperationsFilteredSummary';

@Injectable({
  providedIn: 'root',
})
export class DerivativesCardInfoDataService {
  /**
   * Maps the object NdfOperationFilteredSummary to object DerivativeCardInfo
   * @param operation An object type NdfOperationFilteredSummary
   * @return An object type DerivativeCardInfo
   */
  mapOperationFilteredToDerivativeCardInfo(
    operation: NdfOperationFilteredSummary
  ): DerivativeCardInfo {
    return {
      id: operation.id || '',
      operationDate: operation.operationDate || '',
      dueAt: operation.dueAt || '',
      operationStatus: operation.operationStatus || '',
      financialStatus: operation.financialStatus || '',
      composition: operation.composition || '',
      sequentialId: operation.sequentialId || '',
      settlementDate: operation.settlementDate || '',
      demandSummary: operation.demandSummary || null,
      internationalCurrencyId: operation.internationalCurrencyId || '',
    };
  }

  /**
   * Maps 2 objects to build an object type DerivativeCardInfo
   * @param demand An object type NdfDemandsCalculationsFiltered
   * @param operationToHire An object type NdfDemandsCalculationsOperation
   * @return An object type DerivativeCardInfo
   */
  mapDemandToDerivativeCardInfo(
    demand: NdfDemandsCalculationsFiltered | null,
    operation: NdfDemandsCalculationsOperation
  ): DerivativeCardInfo {
    return {
      id: operation.id || '',
      operationDate: operation.operationDate || '',
      dueAt: operation.dueAt || '',
      operationStatus: operation.operationStatus || '',
      financialStatus: operation.financialStatus || '',
      composition: operation.composition || '',
      sequentialId: operation?.sequentialId || '',
      settlementDate: '',
      demandSummary: {
        sequentialId: demand?.sequentialId || '',
        reference: demand?.reference || null,
      },
      internationalCurrencyId: demand?.internationalCurrencyId || '',
    };
  }
}
